import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=2dc518b6&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc518b6')) {
      api.createRecord('2dc518b6', component.options)
    } else {
      api.reload('2dc518b6', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=2dc518b6&", function () {
      api.rerender('2dc518b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fh6gBCI58yCo/JS/videoIframe.vue"
export default component.exports